import { Platform } from 'react-native';

/**
 * CORE-1733 (возврат QA 23.10) — место под кольцо фокуса у горизонтальных лент.
 *
 * Кольцо клавиатурного фокуса рисуется снаружи элемента: зазор 2px цвета
 * страницы и 2px акцента (public/global.css, `:focus-visible`). Горизонтальный
 * ScrollView react-native-web обрезает всё, что выходит за его рамку, поэтому у
 * вкладок и фильтров /center и чипов /masters кольцо было срезано сверху и снизу,
 * а у первого элемента — и слева.
 *
 * Лента получает внутренний отступ на ширину кольца с запасом и такой же
 * отрицательный внешний — раскладка вокруг не сдвигается, а кольцо помещается
 * целиком. Только веб: на нативе кольца нет.
 */
export const FOCUS_RING_ROOM = 5;

const WEB = Platform.OS === 'web';

/** Стиль самого ScrollView ленты: возвращает место, занятое отступом. */
export const focusRailScroll = WEB
  ? { marginTop: -FOCUS_RING_ROOM, marginBottom: -FOCUS_RING_ROOM, marginLeft: -FOCUS_RING_ROOM, marginRight: -FOCUS_RING_ROOM }
  : null;

/**
 * Отступ контейнера содержимого ленты. `extraRight` — прежний правый отступ
 * ленты (хвост прокрутки), он сохраняется поверх места под кольцо.
 */
export function focusRailContent(extraRight = 0): Record<string, number> | null {
  return WEB
    ? { paddingTop: FOCUS_RING_ROOM, paddingBottom: FOCUS_RING_ROOM, paddingLeft: FOCUS_RING_ROOM, paddingRight: FOCUS_RING_ROOM + extraRight }
    : null;
}

/**
 * Возврат QA 27.10 — элемент ленты, получивший фокус с клавиатуры, докручивается
 * в видимую часть вместе с кольцом. Chrome при фокусе не прокручивает ленту, если
 * элемент виден хотя бы частично: крайний чип /masters оставался срезанным справа,
 * а на 390 px сфокусированный чип — наполовину за краем. `scroll-margin` — место
 * под кольцо, `nearest` — сдвиг ровно до края, без прыжка к центру. Фокус от
 * мыши и пальца ленту не двигает (пометку ставит utils/focusSource).
 */
export function revealFocusedRailItem(e: { currentTarget?: unknown; nativeEvent?: { target?: unknown } } | null | undefined): void {
  if (!WEB || typeof document === 'undefined') return;
  if (document.documentElement.getAttribute('data-focus-source') !== 'keyboard') return;
  const el = (e?.currentTarget ?? e?.nativeEvent?.target) as HTMLElement | null | undefined;
  if (!el || typeof el.scrollIntoView !== 'function') return;
  el.style.scrollMargin = `${FOCUS_RING_ROOM}px`;
  el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}
